import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=318cb512&scoped=true&"
import script from "./menus.vue?vue&type=script&lang=js&"
export * from "./menus.vue?vue&type=script&lang=js&"
import style0 from "./menus.vue?vue&type=style&index=0&id=318cb512&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318cb512",
  null
  
)

export default component.exports